<template>
  <RoamTransaction
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :formsConfig="formsConfig"
    :backButtonRoute="backButtonRoute"
    :screenJson="getScreenJson"
    :dataModel="dataModelToPass"
    :setLoading="setLoading"
    :formItems="getHeaderFormItems"
    :saveDisabled="saveDisabled"
    :localDataGrid="true"
    :saveConfigs="saveConfigs"
    :rowClick="rowClickCallBack"
    :validationSummary="validationSummary"
    :saveFormPopupItems="saveFormPopupItems"
    :barcodeScanned="barcodeScanned"
    :headerConfig="headerConfig"
    :selectedViewValue="selectedViewValue"
    :getSelectedViewType="selectedViewType"
    :detailPopUpFormItems="getDetailPopupFormItems"
    :detailPopUpBack="detailPopUpBack"
    :detailPopUpFormVisible="detailPopUpFormVisible"
    :detailPopUpFormDataModel="detailPopUpFormDataModel"
    :detailPopUpConfig="detailPopUpConfig"
    :saveRoamTransaction="saveRoamTransaction"
    :serverError="serverError"
    :backButtonFunctionOverwrite="backButtonFunctionOverwrite"
    :batchPopUpData="batchPopUpData"
    :ref="'roam-despatch-order'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import RoamTransaction from "@/templates/roam/roam-transaction.vue";
import { RoamTransactionService } from "../../../_services/api/templates/roam-transactions.services";
import { SettingsService } from "../../../_services/api/settings/graycorp/settings.service";
import { ProductUnitOfMeasureService } from "../../../_services/api/products/product-unit-of-measure.service";
import { DespatchOrderService } from "../../../_services/api/sales/despatch-order.service";
import { ProductBatchService } from "../../../_services/api/inventory/product-batch.service";

import IsEqualIgnoreCase from "../../../_helpers/comparison/string-comparison-helper";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: { RoamTransaction },
  watch: {},
  async created() {
    this.resetLabels();
    this.setLoading = true;
    await SettingsService.getBySettingByApplicationFeatureCode(
      "SalesOrderDespatch"
    ).then((res) => {
      this.pickingSettings = res.data.value;
      this.pickingSettings.forEach((element) => {
        if (element.SettingName == "AllowPartPicking") {
          if (element.ScopeCode == "Global") {
            if (element.SettingValue == "Y") this.allowPartPicking = true;
          }
        } else if (element.SettingName == "AllowOverPicking") {
          if (element.ScopeCode == "Global") {
            if (element.SettingValue == "Y") this.allowOverPicking = true;
          }
        }
      });
    });

    await SettingsService.getBySettingByApplicationFeatureCode(
      "OrderPicking"
    ).then((res) => {
      this.orderPickingSettings = res.data.value;
      this.orderPickingSettings.forEach((element) => {
        if (element.SettingName == "SOBatchConsumptionMethod") {
          if (element.ScopeCode == "Global")
            if (element.SettingValue == "Manual") this.fifo = false;
            else this.fifo = true;
        }
      });
    });
    await this.getDespatchData();
    await this.getDetailsData();
  },
  mounted() {},
  data() {
    return {
      detailPopUpFormVisible: false,
      selectedViewValue: 1,
      allowOverPicking: false,
      allowPartPicking: false,
      settingsOverPickingBranchCode: undefined,
      settingsPartPickingBranchCode: undefined,
      pickingSettings: [],
      backButtonRoute: "/roam-despatch-order",
      dataModel: undefined,
      formItems: [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "ConsignmentNo",
              label: {
                text: "Con Note",
              },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                onValueChanged: () => {
                  this.saveDisabled.header = false;
                },
              },
            },
          ],
        },
      ],
      StockUMPickedQtyPreviousValue: undefined,
      validationSummary: [],
      commentItems: [
        "UserComment1",
        "UserComment2",
        "UserComment3",
        "UserComment4",
        "UserComment5",
        "UserComment6",
        "UserComment7",
        "UserComment8",
        "UserComment9",
        "UserComment10",
        "UserComment11",
        "UserComment12",
        "UserComment13",
        "UserComment14",
        "UserComment15",
        "UserComment16",
        "UserComment17",
        "UserComment18",
        "UserComment19",
        "UserComment20",
      ],
      setLoading: false,
      saveDisabled: {
        header: true,
        detail: true,
        line: false,
        save: true,
      },
      productsList: [],
      saveConfigs: {
        // url: "Save_RoamPickingSlip",
        url: "Save_PickingSlip",
        payload: this.getPayload,
      },
      detailPopUpData: {
        EnableSave: false,
      },
      selectedViewType: "details",
      viewPoints: [
        { menuText: "Header", value: 0, type: "header" },
        { menuText: "Details", value: 1, type: "details" },
      ],
      detailPopUpFormDataModel: undefined,
      detailPopupTitle: "NONE",
      serverError: {},
      allBatchData: [],
      batchPopUpData: {
        visible: false,
      },
      orderPickingSettings: [],
      fifo: false, // FIFO Setting - First in First Out
      productFilterGroupAvailability: false,
      DespatchPackagingSelectionModel: {
        SelectPackaging: undefined,
      },
    };
  },
  computed: {
    detailPopUpConfig() {
      return {
        save: {
          text: this.detailPopupTitle == "NONE" ? "Update" : "CONFIRM",
          clickCallback: () => {
            this.detailPopUpSaveButtonClick();
          },
          disabled:
            this.detailPopupTitle == "NONE"
              ? !this.detailPopUpData.EnableSave
              : this.saveDisabled.save,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.detailPopUpBackButtonClick();
          },
        },
        option: {
          title: {
            text: this.detailPopupTitle,
            visible: this.detailPopupTitle == "NONE" ? false : true,
          },
        },
      };
    },
    headerConfig() {
      return {
        options: {
          multiViewSelect: true,
          viewPoints: this.viewPoints,
        },
        data: {
          multiViewOption: {
            items: this.viewPoints,
            keyExpr: "value",
            valueExpr: "value",
            displayExpr: "menuText",
            value: this.selectedViewValue,
            width: this.isXSmall ? 85 : 150,
            onItemClick: (e) => {
              // console.log("Menu Click ", e);
              e.component.close();
            },
            onValueChanged: (e) => {
              // console.log("On Value Change ", e);
              this.viewChange(e);
            },
          },
        },
      };
    },
    getAllowPartPicking() {
      return this.allowPartPicking;
    },
    getAllowOverPicking() {
      return this.allowOverPicking;
    },
    dataModelToPass() {
      return this.dataModel;
    },
    getScreenJson() {
      var screenConfig = {
        formItems: [],
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              expand: "Product",
              localDataList: true,
              items: this.productsList,
            },
            // noDataMessage: {
            //   addNew: {
            //     class: "hooray",
            //     title: "No Orders",
            //     message:
            //       "Your work is complete, all orders have been despatched.",
            //   },
            // },
            options: {
              pageSize: 100,
              allowedPageSizes: [25, 50, 100],
              wordWrapEnabled: this.isXSmall ? false : true,
              rowSelect: true,
              onRowPreparedCallBack: this.onRowPreparedCallBack,
              keyboardNavigation: {
                key: ["ItemCode", "LineNo"],
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
          },
          columns: [
            {
              screenField: "StockUMBackOrderQty",
              allowEditing: false,
              label: "Picked",
              dataField: "StockUMBackorderQty",
              cellTemplate: "Custom",
              customTemplate: true,
              displayValue: (data) => {
                return data.StockUMPickedQty + "/" + data.StockUMBackorderQty;
              },
              minWidth: 100,
              width: 100,
              cssClass: "roam-column",
            },
            {
              screenField: "Name",
              allowEditing: false,
              dataField: "ItemDescription",
              minWidth: 175,
              cellTemplate: (data, info) => {
                return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.ItemDescription}
                        </span> <br />
                        <span class="record-secondary gc-grid-code">
                          ${info.data.ItemCode}
                        </span>
                      </div>`);
              },
              // minWidth: this.isXSmall ? 175 : undefined,
              // width: this.isXSmall ? 175 : undefined,
              cssClass: "roam-column",
            },
            {
              screenField: "Code",
              allowEditing: false,
              label: "Bin",
              dataField: "BinLocationCode",
              minWidth: 50,
              cssClass: "roam-column",
            },
          ],
        },
      };

      return screenConfig;
    },

    getHeaderFormItems() {
      return this.formItems;
    },
    totalStockUMBackorderQty() {
      let total = 0;
      this.productsList.forEach((item) => {
        total += item.StockUMBackorderQty;
      });
      return total;
    },
    totalScanned() {
      let totalScanned = 0;

      this.productsList.forEach((item) => {
        totalScanned += item.StockUMPickedQty;
      });
      return totalScanned;
    },
    getDetailPopupFormItems() {
      var items = [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "ItemCode",
              label: {
                text: "Code",
              },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                readOnly: true,
              },
            },
            {
              dataField: "ItemDescription",
              label: {
                text: "Product",
              },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                readOnly: true,
              },
            },
            {
              dataField: "Product.UnitOfMeasureCode",
              label: {
                text: "UM",
              },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                readOnly: true,
              },
            },
            {
              dataField: "BinLocationCode",
              label: {
                text: "Location",
              },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                readOnly: true,
              },
            },
            {
              dataField: "StockUMBackorderQty",
              label: {
                text: "Outstanding",
              },
              editorType: "dxNumberBox",
              editorOptions: {
                readOnly: true,
              },
            },
            {
              dataField: "StockUMPickedQty",
              label: {
                text: "Picked",
              },
              editorType: "dxNumberBox",
              editorOptions: {
                onValueChanged: (e) => {
                  this.detailsStockUMPickedQtyValueChange(e);
                },
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                step: 0,
                min: 0,
              },
            },
            {
              dataField: "Completed",
              label: {
                text: "Complete",
              },
              editorType: "dxCheckBox",
              editorOptions: {
                readOnly:
                  this.detailPopUpFormDataModel &&
                  this.detailPopUpFormDataModel.StockUMPickedQty >=
                    this.detailPopUpFormDataModel.StockUMBackorderQty,
                allowUpdate: this.getAllowPartPicking,
                onValueChanged: () => {
                  this.detailsCompleteValueChange();
                },
              },
            },
          ],
        },
      ];

      return this.detailPopupTitle == "NONE"
        ? items
        : this.detailPopupTitle == "Despatch Packaging Selection"
        ? this.getPackagingSelectionFormItems
        : this.saveFormPopupItems;
    },
    saveFormPopupItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "SaveOption",
              label: {
                text: "SaveOption",
                visible: false,
              },
              editorType: "dxRadioGroup",
              editorOptions: {
                items: [
                  { value: "Keep order open for more picks today", id: 1 },
                  {
                    value:
                      "Generate Invoice and Close All Open Lines and Order",
                    id: 2,
                  },
                  { value: "Generate Invoice and Backorder Open Lines", id: 3 },
                ],
                valueExpr: "id",
                displayExpr: "value",
                onValueChanged: () => {
                  this.saveFormPopupValueChange();
                },
                elementAttr: { class: "roam-despatch-radio-list" },
              },
            },
          ],
        },
      ];
    },
    getPackagingSelectionFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "SelectPackaging.ItemCode",
              label: {
                text: "SelectPackaging",
                visible: false,
              },
              editorType: "dxSelectBox",
              editorOptions: {
                placeholder: "Select Packaging",
                dataSource: RoamTransactionService.dataSourceConfig(
                  "api/CustomerProductsWithProductFilterGroup",
                  {
                    filter: [
                      ["CustomerCode", "=", this.dataModel.CustomerCode],
                      "and",
                      [
                        "ProductFilterGroupType",
                        "=",
                        "Prompted Sales Despatch Inclusion",
                      ],
                    ],
                  }
                ),
                valueExpr: "ItemCode",
                displayExpr: "Description",
                searchExpr: ["ItemCode"],
                searchMode: "contains",
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.ItemCode}" >
                <span class="auto-complete-primary">
                  ${data.Description}
                </span>
                <span class="record-secondary gc-grid-code">
                  ${data.ItemCode}
                </span>
              </div>`;
                },
                showClearButton: true,
                onValueChanged: (e) => {
                  this.onSelectPackagingValueChanged(e);
                },
                // elementAttr: { class: "roam-despatch-radio-list" },
              },
            },
          ],
        },
      ];
    },
  },
  methods: {
    onRowPreparedCallBack(e) {
      if (e.rowType == "data") {
        if (e.data.Completed) {
          e.rowElement.classList.add("row-complete");
        } else {
          e.rowElement.classList.remove("row-complete");
        }
      }
    },
    async backButtonFunctionOverwrite() {
      try {
        let result = await RoamTransactionService.deletePickingSlipStartTime(
          this.dataModelToPass.SalesOrderCode
        );
        this.$logger.debug("DeletePickingSlipStartTime Success ", result);
      } catch (error) {
        this.$logger.debug("DeletePickingSlipStartTime err ", error);
      }

      this.$router.push({
        path: this.backButtonRoute,
      });
    },
    detailPopUpSaveButtonClick() {
      this.detailPopUpFormVisible = false;
      var save = false;
      if (this.detailPopupTitle == "Incomplete Pick") save = true;
      this.detailPopupTitle != "NONE"
        ? this.saveRoamTransaction(save)
        : undefined;

      this.updateTertiaryLabel(
        this.totalScanned + "/" + this.totalStockUMBackorderQty
      );
    },
    detailPopUpBackButtonClick() {
      this.detailPopUpFormVisible = false;

      if (this.detailPopUpData != undefined) {
        // if (
        //   !this.allowPartPicking &&
        //   this.detailPopUpData.StockUMPickedQty <
        //     this.detailPopUpData.StockUMBackorderQty
        // ) {
        //   this.detailPopUpData.StockUMPickedQty = 0;
        // }
        if (this.detailPopUpData.previousValue != undefined)
          this.detailPopUpData.StockUMPickedQty =
            this.detailPopUpData.previousValue;
      }

      this.updateTertiaryLabel(
        this.totalScanned + "/" + this.totalStockUMBackorderQty
      );

      this.dataModel.SaveOption = undefined;
      if (
        this.detailPopupTitle == "Incomplete Pick" &&
        this.productFilterGroupAvailability
      ) {
        this.saveRoamTransaction();
      } else this.detailPopupTitle = undefined;
      this.saveDisabled.save = true;
    },
    async saveRoamTransaction(save) {
      let allItemsPicked = true;
      this.productsList.forEach((el) => {
        let qtyPicked = (
          el.StockUMPickedQty / el.SalesUMConversion
        ).roundNumber(2);
        if (qtyPicked < el.StockUMBackorderQty) {
          allItemsPicked = false;
        }
      });

      if (!this.allowPartPicking && !allItemsPicked) {
        this.validationSummary = [];
        this.validationSummary.push({
          message:
            "One or more lines are not fully picked. Please complete picking all lines in full before attempting to save.",
        });
      } else {
        if (
          this.productFilterGroupAvailability &&
          this.detailPopupTitle != "Despatch Packaging Selection" &&
          save != true
        ) {
          this.detailPopupTitle = "Despatch Packaging Selection";

          this.detailPopUpFormDataModel = this.DespatchPackagingSelectionModel;
          this.detailPopUpFormVisible = true;

          this.detailPopUpData = undefined;

          setTimeout(() => {
            // if (this.DespatchPackagingSelectionModel.SelectPackaging)
            this.saveDisabled.save = false;
          }, 100);
        } else {
          var payload = this.getPayload();
          if (payload == "incomplete-pick") {
            this.saveDisabled.save = true;
            this.detailPopupTitle = "Incomplete Pick";

            this.detailPopUpFormDataModel = this.dataModel;
            this.detailPopUpFormVisible = true;

            this.detailPopUpData = undefined;
          } else {
            // console.log('ROAM CX ', JSON.stringify(payload)); //10212
            this.setLoading = true;
            // console.log("saveRoamTransaction ", payload);
            await RoamTransactionService.saveRoamTransaction(
              this.saveConfigs.url,
              payload
            )
              .then((res) => {
                if (res) this.setLoading = false;
                // console.log("saveRoamTransaction err", res);
                this.$notify("Picking Details saved successfully", "success");
                this.setIgnoreRouteChangeConfirmation();
                this.$router.push({
                  path: "/roam-despatch-order",
                });
              })
              .catch((err) => {
                if (err)
                  // console.log("saveRoamTransaction err", err);
                  this.setLoading = false;
                this.dataModel.SaveOption = undefined;
                // this.displayServerError(err, "Picking Details save failed");
                this.serverError = {
                  err: err,
                  msg: "Picking Details save failed",
                  time: new Date().getTime(),
                };
              });
          }
        }
      }
    },
    viewChange(e) {
      this.selectedViewValue = e.value;
      this.selectedViewType = this.viewPoints.filter((a) => {
        return a.value == e.value;
      })[0].type;
    },
    async detailsStockUMPickedQtyValueChange(e) {
      if (e.previousValue != undefined && e.previousValue != null)
        this.detailPopUpData.previousValue = e.previousValue;
      if (e.value == null) this.detailPopUpData.StockUMPickedQty = 0;
      this.saveDisabled.detail = false;
      this.saveDisabled.line = true;
      this.detailPopUpData.EnableSave = true;
      if (this.detailPopUpData.StockUMPickedQty == 0) {
        // this.detailPopUpData.StockUMPickedQtyChange = false;
        return;
      }

      if (
        !this.allowPartPicking &&
        this.detailPopUpData.StockUMPickedQty <
          this.detailPopUpData.StockUMBackorderQty
      ) {
        this.validationSummary = [];
        this.validationSummary.push({
          message:
            "The picked quantity must equal the outstanding quantity. Please rectify this before updating this line.",
        });
        this.saveDisabled.detail = true;
        this.saveDisabled.line = false;
        this.detailPopUpData.EnableSave = false;
        // this.detailPopUpData.StockUMPickedQty = 0;

        return;
      }

      if (
        !this.allowOverPicking &&
        this.detailPopUpData.StockUMPickedQty >
          this.detailPopUpData.StockUMBackorderQty
      ) {
        let confirmLeaving = await this.$confirm(
          "You cannot over pick the order quantity. Do you wish to continue?",
          "Validation"
        );
        if (confirmLeaving) {
          this.detailPopUpData.StockUMPickedQty =
            this.detailPopUpData.StockUMBackorderQty;
        } else {
          this.detailPopUpData.StockUMPickedQty = 0;
          this.detailPopUpData.StockUMPickedQtyChange = true;
          this.detailPopUpData.EnableSave = false;
        }
      } else if (
        this.allowOverPicking &&
        this.detailPopUpData.StockUMPickedQty >
          this.detailPopUpData.StockUMBackorderQty
      ) {
        let confirmLeaving = await this.$confirm(
          "You have over picked the order quantity. Do you wish to continue?",
          "Validation"
        );
        if (confirmLeaving) {
          // return;
        } else {
          this.detailPopUpData.StockUMPickedQty = 0;
          this.detailPopUpData.StockUMPickedQtyChange = true;
          this.detailPopUpData.EnableSave = false;
        }
      }

      // if (!this.allowOverPicking) {
      //   this.validationSummary = [];
      //   if (
      //     this.detailPopUpData.StockUMPickedQty !=
      //     this.detailPopUpData.StockUMBackorderQty
      //   ) {
      //     this.StockUMPickedQtyPreviousValue = e.previousValue;
      //     let confirmLeaving = await this.$confirm(
      //       "This order seemed to be either under/over picked. Do you wish to continue?",
      //       "Validation"
      //     );
      //     if (confirmLeaving) {
      //       this.detailPopUpData.StockUMPickedQty =
      //         this.detailPopUpData.StockUMBackorderQty;
      //     } else {
      //       this.detailPopUpData.StockUMPickedQty = 0;
      //       this.detailPopUpData.StockUMPickedQtyChange = true;
      //     }
      //   }
      // } else {
      //   if (
      //     this.detailPopUpData.StockUMPickedQty >
      //     this.detailPopUpData.StockUMBackorderQty
      //   ) {
      //     this.StockUMPickedQtyPreviousValue = e.previousValue;
      //     let confirmLeaving = await this.$confirm(
      //       "You have over picked the order quantity. Do you wish to continue?",
      //       "Validation"
      //     );
      //     if (confirmLeaving) {
      //       // return;
      //     } else {
      //       this.detailPopUpData.StockUMPickedQty = 0;
      //       this.detailPopUpData.StockUMPickedQtyChange = true;
      //     }
      //   }
      // }

      if (
        this.detailPopUpData.StockUMPickedQty >=
        this.detailPopUpData.StockUMBackorderQty
      )
        this.detailPopUpData.Completed = true;
      else this.detailPopUpData.Completed = false;

      this.updateTertiaryLabel(
        this.totalScanned + "/" + this.totalStockUMBackorderQty
      );
    },
    detailsCompleteValueChange() {
      this.detailPopUpData.EnableSave = true;
      this.saveDisabled.line = true;
    },
    onSelectPackagingValueChanged(e) {
      var item = e.component
        .getDataSource()
        .items()
        .find((x) => x.ItemCode == e.value);

      this.DespatchPackagingSelectionModel.SelectPackaging = item;
      this.saveFormPopupValueChange();
    },
    saveFormPopupValueChange() {
      this.saveDisabled.save = false;
    },
    // detailPopUpDataCallBack(data) {
    //   this.detailPopUpData = data;
    // },
    detailPopUpBack(e) {
      if (this.StockUMPickedQtyPreviousValue != undefined) {
        e.data.StockUMPickedQty = this.StockUMPickedQtyPreviousValue;

        e.data.StockUMPickedQtyChange = true;
        this.StockUMPickedQtyPreviousValue = undefined;
      }

      this.detailPopUpData.StockUMPickedQty = 0;
      this.saveDisabled.line = false;
    },
    getPayload() {
      // Make sure all items have been picked
      // Because, when over picking is allowed, there may be multiple items un-picked but the
      // allocated and required totals could be equal. Without making sure that each item is fully-picked
      // then it would be invoiced without warning.
      // i.e
      //  50/20 Lemons (we have overed picked here)
      //   0/30 Oranges
      // Without the all items picked check, this would not be recognized as an incomplete order since there
      // is a total of 50 items picked.
      let allItemsPicked = true;
      this.productsList.forEach((el) => {
        let qtyPicked = el.StockUMPickedQty.roundNumber(2);
        if (qtyPicked < el.StockUMBackorderQty) {
          allItemsPicked = false;
        }
      });

      if (
        allItemsPicked ||
        this.dataModelToPass.SaveOption != undefined ||
        (this.selectedViewValue == 0 && this.totalScanned == 0)
      ) {
        var setComplete = false;
        this.dataModelToPass.DateIn = new Date();
        this.dataModelToPass.ProcessInvoice = "Y";
        if (this.dataModelToPass.SaveOption == 1) {
          this.dataModelToPass.ProcessInvoice = "N";
        } else if (this.dataModelToPass.SaveOption == 2) {
          this.dataModelToPass.ProcessInvoice = "Y";
          setComplete = true;
        } else if (this.dataModelToPass.SaveOption == 3) {
          this.dataModelToPass.ProcessInvoice = "Y";
        }

        let RoamPickingSlipDetails = [];
        this.productsList.forEach((el) => {
          let entry = {};
          entry.BatchStockTolerance = el.Product.BatchStockTolerance;
          // entry.IsBatchProduct = el.Product.IsBatchProduct;
          entry.ItemCode = el.ItemCode;
          entry.LineNo = el.LineNo;
          entry.SalesUM = el.SalesUM;
          entry.SalesUMConversion = el.SalesUMConversion;
          entry.SalesUMInvoiceConversion = el.SalesUMConversion;
          entry.SalesUMIsVariable = el.SalesUMIsVariable;
          // entry.SalesUMQuantityToPick = el.StockUMPickedQty; // 2
          entry.SalesUMQuantityToPick = (
            el.StockUMPickedQty / el.SalesUMConversion
          ).roundNumber(2);
          entry.StockUM = el.Product.UnitOfMeasureCode;
          entry.StockUMQuantityToPick = el.StockUMPickedQty; // el.StockUMPickedQty * (el.SalesUMConversion == 0 ? 1 : el.SalesUMConversion); // 1
          entry.Completed = el.Completed
            ? "Y"
            : setComplete
            ? "Y"
            : entry.SalesUMQuantityToPick >= el.SalesUMBackorderQty
            ? "Y"
            : "N";
          entry.PickingSlipProductBatches = [];

          if (el.ChildDataSource) {
            let validBatches = el.ChildDataSource.filter((b) => {
              return b.BatchNo !== "" && b.Qty > 0;
            });

            validBatches.forEach((i) => {
              let objBatch = {
                BatchNo: i.BatchNo,
                SalesUMInvoiceConversion: el.SalesUMConversion,
                SalesUMQuantityToPick: i.Qty / el.SalesUMConversion,
                StockUMQuantityToPick: i.Qty,
                SupplierCode: i.SupplierCode,
              };
              entry.PickingSlipProductBatches.push(objBatch);
            });
          }

          RoamPickingSlipDetails.push(entry);
        });

        if (
          this.productFilterGroupAvailability &&
          this.DespatchPackagingSelectionModel.SelectPackaging
        ) {
          RoamPickingSlipDetails.push({
            ItemCode:
              this.DespatchPackagingSelectionModel.SelectPackaging.ItemCode,
            LineNo: 0,
            BatchStockTolerance: 0,
            SalesUMConversion: 1,
            SalesUMInvoiceConversion: 1,
            SalesUMIsVariable: false,
            SalesUMQuantityToPick: 1,
            StockUMQuantityToPick: 1,
            StockUMSuppliedQty: 0,
            SalesUM:
              this.DespatchPackagingSelectionModel.SelectPackaging
                .UnitOfMeasure,
            StockUM:
              this.DespatchPackagingSelectionModel.SelectPackaging
                .UnitOfMeasure,
          });
        }

        let payload = {
          DateIn: this.dataModelToPass.DateIn.toSaveDate(),
          ProcessInvoice: this.dataModelToPass.ProcessInvoice,
          PartDeliver: "Y", // this.dataModelToPass.PartDeliver ? "Y" : "N",
          BackOrder: "Y", // this.dataModelToPass.BackOrder ? "Y" : "N",
          DeliveryAddressCompanyName:
            this.dataModelToPass.DeliveryAddressCompanyName,
          DeliveryAddressCountry: this.dataModelToPass.DeliveryAddressCountry,
          DeliveryAddressPostcode: this.dataModelToPass.DeliveryAddressPostcode,
          DeliveryAddressState: this.dataModelToPass.DeliveryAddressState,
          DeliveryAddressStreetLine1:
            this.dataModelToPass.DeliveryAddressStreetLine1,
          DeliveryAddressStreetLine2:
            this.dataModelToPass.DeliveryAddressStreetLine2,
          DeliveryAddressSuburb: this.dataModelToPass.DeliveryAddressSuburb,
          ConsignmentNo: this.dataModelToPass.ConsignmentNo,
          SalesOrderCode: this.dataModelToPass.SalesOrderCode.toString(),
          UserComment1: this.dataModelToPass.UserComment1,
          UserComment10: this.dataModelToPass.UserComment10,
          UserComment11: this.dataModelToPass.UserComment11,
          UserComment12: this.dataModelToPass.UserComment12,
          UserComment13: this.dataModelToPass.UserComment13,
          UserComment14: this.dataModelToPass.UserComment14,
          UserComment15: this.dataModelToPass.UserComment15,
          UserComment16: this.dataModelToPass.UserComment16,
          UserComment17: this.dataModelToPass.UserComment17,
          UserComment18: this.dataModelToPass.UserComment18,
          UserComment19: this.dataModelToPass.UserComment19,
          UserComment2: this.dataModelToPass.UserComment2,
          UserComment20: this.dataModelToPass.UserComment20,
          UserComment3: this.dataModelToPass.UserComment3,
          UserComment4: this.dataModelToPass.UserComment4,
          UserComment5: this.dataModelToPass.UserComment5,
          UserComment6: this.dataModelToPass.UserComment6,
          UserComment7: this.dataModelToPass.UserComment7,
          UserComment8: this.dataModelToPass.UserComment8,
          UserComment9: this.dataModelToPass.UserComment9,
          // RoamPickingSlipDetails: RoamPickingSlipDetails,
          PickingSlipDetails: RoamPickingSlipDetails,
          ScreenName: "Order Despatch Console",
          PickAllGeneralLedgerLines: "Y",
          PickAllNonstockProductLines: "Y",
          AutoBatchAllocation: this.fifo ? "Y" : "N",
        };
        return payload;
      } else {
        return "incomplete-pick";
      }
    },
    async getDetailsData() {
      var batchProdCodes = [];
      await RoamTransactionService.getDataSet({
        url: "api/PickingSlipDetail",
        filter: [
          "SalesOrderCode eq " +
            this.baseView.id +
            " and Product/StockItem eq 'Y' and (Status eq 'A' or Status eq 'I')",
        ],
        expand:
          "Product($select=BatchStockTolerance,Code,Description1,IsBatchProduct,UnitOfMeasureCode)",
        select: [
          "BatchNo",
          "BinLocationCode",
          "CustomerCode",
          "DateIn",
          "IsBatchProduct",
          "ItemCode",
          "ItemDescription",
          "ItemType",
          "LineNo",
          "SalesOrderCode",
          "SalesOrderType",
          "SalesTaxPcnt",
          "SalesUM",
          "SalesUMBackorderQty",
          "SalesUMConversion",
          "SalesUMSuppliedQty",
          "StockUMBackorderQty",
          "StockUMOrderQty",
          "StockUMSuppliedQty",
          "UnitOfMeasureCode",
        ],
      })
        .then(async (res) => {
          res.data.value.forEach((element) => {
            element["StockUMPickedQty"] = 0;
            element["Completed"] = false;
            element["EnableSave"] = false;
          });

          this.productsList = res.data.value;

          this.productsList.forEach(async (element) => {
            if (element.IsBatchProduct != "No") {
              batchProdCodes.push(element.ItemCode);
              await this.loadAllocatedBatchData(element);
            }
          });

          this.updateTertiaryLabel(
            this.totalScanned + "/" + this.totalStockUMBackorderQty
          );

          if (batchProdCodes.length != 0) {
            await this.loadAllBatchData(batchProdCodes);
          } else this.setLoading = false;

          var grid =
            this.$refs["roam-despatch-order"].$refs[
              "roamTransactionGrid-" + this.selectedViewValue
            ];

          grid[0].gridRepaint2();
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          if (err) console.log("getDetailsData err", err);
          this.setLoading = false;
        });
    },
    async loadAllocatedBatchData(element) {
      await DespatchOrderService.getPickingSlipProductBatch(
        `ItemCode eq '${element["ItemCode"]}' and SalesOrderLineNo eq ${element["LineNo"]} and SalesOrderCode eq ${element["SalesOrderCode"]}`,
        { orderby: "UseByDate asc" }
      )
        .then((response) => {
          var totalQTY = 0;
          element["ChildDataSource"] = response.data.value;
          element["LoadBatchDataSource"] = false;
          element["ChildDataSource"].forEach((batch) => {
            batch.Qty = 0;
            // batch.AllocatedQty;
            // totalQTY = totalQTY + batch.AllocatedQty;
          });
          element["StockUMPickedQty"] = totalQTY;

          if (element["StockUMPickedQty"] > 0) this.saveDisabled.detail = false;

          // if (totalQTY == element["SalesUMBackorderQty"])
          //   element["Completed"] = true;
          // else element["Completed"] = false;

          element["ChildDataSource_COPY"] = element["ChildDataSource"].slice();

          // if (element["ChildDataSource"].length == 0) {
          //   element["ChildDataSource"].push({
          //     AllocatedQty: 0,
          //     AvailableQty: 0,
          //     BatchNo: undefined,
          //     BranchCode: undefined,
          //     CompanyCode: undefined,
          //     ItemCode: undefined,
          //     OnHand: undefined,
          //     Qty: undefined,
          //     SalesOrderCode: undefined,
          //     SalesOrderLineNo: undefined,
          //     SupplierBatchNo: undefined,
          //     SupplierCode: undefined,
          //     SupplierName: undefined,
          //     UseByDate: undefined,
          //   });
          // }

          this.setLoading = false;
        })
        .then(() => {
          this.setLoading = false;
          if (element["ChildDataSource"].length > 0) {
            var Totalpicked = 0;
            element["ChildDataSource"].forEach((row) => {
              if (row.Qty > 0) {
                Totalpicked = Totalpicked + row.Qty;
                element.CheckInclude = true;
              }
            });
            element.totalPickedQty = Totalpicked;
            element.StockUMQuantityToPick =
              Totalpicked * element.SalesUMConversion;
            if (Totalpicked == element["SalesUMBackorderQty"]) {
              element["Completed"] = true;
            }
            if (Totalpicked < element["SalesUMBackorderQty"]) {
              element["Completed"] = false;
            }
          }
        });
    },
    async loadAllBatchData(batchProdCodes) {
      var filter = undefined;
      batchProdCodes.forEach((element) => {
        if (!filter) filter = `ItemCode eq '${element}'`;
        else filter = filter + ` or ItemCode eq '${element}'`;
      });

      // filter = `BranchCode eq '${this.dataModel.BranchCode}' and ` + filter;

      await ProductBatchService.getAllBatchNoByBranch(
        filter,
        this.dataModel.BranchCode,
        [
          "AllocatedQty",
          "AvailableQty",
          "BatchNo",
          "BatchStockTolerance",
          "BestBeforeDate",
          "BestBeforeDateForSort",
          "BranchCode",
          "DateCreated",
          "ItemCode",
          "OnHand",
          "ProductDescrition1",
          "SupplierCode",
          "UseByDate",
          "UseByDateForSort",
        ]
      )
        .then((res) => {
          this.allBatchData = res.data.value;
          this.setLoading = false;
        })
        .catch((err) => {
          if (err) this.setLoading = false;
        });
    },
    updateTertiaryLabel(labelText) {
      this.$store.dispatch("transactionTemplate/setTertiaryLabel", labelText);
    },
    async getDespatchData() {
      await RoamTransactionService.getByCode(
        "PickingSlip",
        `SalesOrderCode eq ${this.baseView.id}`,
        [
          "BranchCode",
          "DivisionCode",
          "CompanyCode",
          "ConsignmentNo",
          "CreatedBy",
          "Currency",
          "CustomerCode",
          "CustomerDeliveryAddressLineNo",
          "DeliveryAddressCompanyName",
          "DeliveryAddressCountry",
          "DeliveryAddressPostcode",
          "DeliveryAddressState",
          "DeliveryAddressStreetLine1",
          "DeliveryAddressStreetLine2",
          "DeliveryAddressSuburb",
          "SalesOrderCode",
          "SalesOrderTypeCode",
          "SalesRepresentativeCode",
          "ShipComment",
          "ShipDate",
          "Status",
          "UserComment1",
          "UserComment2",
          "UserComment3",
          "UserComment4",
          "UserComment5",
          "UserComment6",
          "UserComment7",
          "UserComment8",
          "UserComment9",
          "UserComment10",
          "UserComment11",
          "UserComment12",
          "UserComment13",
          "UserComment14",
          "UserComment15",
          "UserComment16",
          "UserComment17",
          "UserComment18",
          "UserComment19",
          "UserComment20",
        ]
      )
        .then(async (res) => {
          this.dataModel = res.data.value[0];
          this.dataModel["SaveOption"] = undefined;

          this.pickingSettings.forEach((element) => {
            if (element.SettingName == "AllowPartPicking") {
              if (element.ScopeCode == "Branch") {
                if (element.ScopeValue == this.dataModel.BranchCode)
                  if (element.SettingValue == "Y") this.allowPartPicking = true;
                  else this.allowPartPicking = false;
              }
            } else if (element.SettingName == "AllowOverPicking") {
              if (element.ScopeCode == "Branch") {
                if (element.ScopeValue == this.dataModel.BranchCode)
                  if (element.SettingValue == "Y") this.allowOverPicking = true;
                  else this.allowOverPicking = false;
              }
            }
          });

          this.orderPickingSettings.forEach((element) => {
            if (element.SettingName == "SOBatchConsumptionMethod") {
              if (element.ScopeCode == "Branch")
                if (element.ScopeValue == this.dataModel.BranchCode)
                  if (element.SettingValue == "Manual") this.fifo = false;
                  else this.fifo = true;
            }
          });

          this.$store.dispatch(
            "transactionTemplate/setPrimaryLabel",
            "Sales Order " + this.dataModel.SalesOrderCode
          );

          this.$store.dispatch(
            "transactionTemplate/setSecondaryLabel",
            this.dataModel.DeliveryAddressCompanyName
          );

          await RoamTransactionService.getByCode(
            "SalesOrderType",
            `Code eq '${this.dataModel["SalesOrderTypeCode"]}'`
          )
            .then((soType) => {
              var commentConfig = soType.data.value[0];
              this.commentItems.forEach((element, i) => {
                var item = {
                  dataField: element,
                  label: {
                    text: commentConfig["CommentLabel" + (i + 1)],
                  },
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                    onValueChanged: () => {
                      this.saveDisabled.header = false;
                    },
                  },
                  visible: commentConfig["CommentLabel" + (i + 1)] != "",
                  validationRules:
                    commentConfig["CommentRequired" + (i + 1)] == "Y"
                      ? [
                          {
                            type: "required",
                            message: `${
                              commentConfig["CommentLabel" + (i + 1)]
                            } is required`,
                            validationMessageMode: "always",
                          },
                        ]
                      : [],
                };

                this.formItems[0].items.push(item);
              });
              this.setLoading = false;
            })
            .catch((err) => {
              this.$logger.debug("getSoType err ", err);
            });

          // Request any Product Filter Group items for SO-Customer
          await RoamTransactionService.getByCode(
            "CustomerProductsWithProductFilterGroup",
            `CustomerCode eq '${this.dataModel.CustomerCode}' and ProductFilterGroupType eq 'Prompted Sales Despatch Inclusion'`
          ).then((res) => {
            if (res.data.value.length != 0)
              this.productFilterGroupAvailability = true;
          });
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          if (err) console.log("err", err);
        });
    },
    rowClickCallBack(e) {
      if (e.rowType == "data") {
        // eslint-disable-next-line no-console
        // console.log("--->", e.key, e.rowIndex);
        // this.saveDisabled.detail = true;

        if (this.fifo == true || e.data.IsBatchProduct == "No") {
          this.detailPopupTitle = "NONE";
          this.detailPopUpFormDataModel = e.data;
          this.detailPopUpFormVisible = true;

          this.detailPopUpData = e.data;
          this.detailPopUpData.previousValue = undefined;
          this.detailPopUpData.EnableSave = false;
        } else {
          // New ROAM Batch Controlled UI
          this.setLoading = true;
          this.getProductBatchDetails(e.data);
        }
      }
    },

    searchItemIndexes(itemCode, salesUM) {
      let itemIndexes = [];
      this.productsList.forEach((item, index) => {
        // We can pick a product using different Unit of Measures. Locking it to the 1 unit of measure on the order BREAKS this behaviour.
        // if (item["ItemCode"] == itemCode && item["SalesUM"] == salesUM) {
        if (
          IsEqualIgnoreCase(item["ItemCode"], itemCode) &&
          salesUM == salesUM
        ) {
          itemIndexes.push(index);
        }
      });
      return itemIndexes;
    },

    searchByItemCode(itemCode, salesUM) {
      let match = null;
      this.productsList.forEach((item) => {
        // We can pick a product using different Unit of Measures. Locking it to the 1 unit of measure on the order BREAKS this behaviour.
        // if (item["ItemCode"] == itemCode && item["SalesUM"] == salesUM) {
        if (
          IsEqualIgnoreCase(item["ItemCode"], itemCode) &&
          salesUM == salesUM
        ) {
          match = item;
        }
      });
      return match;
    },

    async barcodeScanned(barcode) {
      if (barcode) {
        this.setLoading = true;
        ProductUnitOfMeasureService.getByBarcodeAndBranchCode(
          barcode,
          this.dataModelToPass.BranchCode,
          ["Barcode", "BranchCode", "ProductCode", "UnitOfMeasureCode", "ConversionFactor"]
        )
          .then((res) => {
            this.$logger.debug(
              `ProductUnitOfMeasureService  ${JSON.stringify(res)}`
            );
            let productUOM = res.data.value[0];

            if (productUOM) {
              let itemIndexes = this.searchItemIndexes(
                productUOM.ProductCode,
                productUOM.UnitOfMeasureCode
              );
              let itemIndex = -1;
              if (itemIndexes.length > 0) {
                itemIndex = itemIndexes[0];
              }

              let item = this.searchByItemCode(
                productUOM.ProductCode,
                productUOM.UnitOfMeasureCode
              );

              let quantityToAdd = 0;
              this.$logger.debug("itemIndex", itemIndex);
              if (itemIndex == -1) {
                this.setLoading = false;
                this.displayGenericAlert(
                  `Product ${productUOM.ProductCode}:${productUOM.Product.Description1} is not in this order`
                );
              } else {
                if (this.fifo == true || item.IsBatchProduct == "No") {
                  for (let i = 0; i < itemIndexes.length; i++) {
                    itemIndex = itemIndexes[i];
                    if (
                      IsEqualIgnoreCase(
                        productUOM.UnitOfMeasureCode,
                        productUOM.Product.UnitOfMeasureCode
                      )
                    ) {
                      quantityToAdd = 1;
                    } else if (
                      IsEqualIgnoreCase(
                        productUOM.UnitOfMeasureCode,
                        item.SalesUM
                      )
                    ) {
                      this.$logger.debug(
                        `item.SalesUMConversion ${item.SalesUMConversion}`
                      );
                      quantityToAdd = item.SalesUMConversion;
                    } else if (productUOM.UnitOfMeasureCode != item.SalesUM) {
                      quantityToAdd = productUOM.ConversionFactor;
                    }

                    if (
                      this.productsList[itemIndex].StockUMPickedQty +
                        quantityToAdd <=
                      this.productsList[itemIndex].StockUMBackorderQty
                    ) {
                      break;
                    }
                  }

                  this.setLoading = false;
                  this.updatePickedQty(itemIndex, quantityToAdd);
                } else {
                  // New ROAM Batch Controlled UI
                  this.getProductBatchDetails(item);
                }
              }
            } else {
              this.setLoading = false;
              this.displayGenericAlert(`Product does not exist for barcode`);
            }
          })
          .catch((err) => {
            this.setLoading = false;
            this.$logger.debug(`errors, ${JSON.stringify(err)}`);
            this.displayGenericAlert(
              "ProductUnitOfMeasureService get call failed."
            );
          });
      }
    },
    getProductBatchDetails(element) {
      this.setLoading = false;
      this.batchPopUpData = {
        ...{
          visible: true,
          data: JSON.parse(JSON.stringify(element)),
          po_batchData: [...this.allBatchData],
          callBack: this.batchPopUpCallBack,
          pickingSettings: {
            allowPartPicking: this.allowPartPicking,
            allowOverPicking: this.allowOverPicking,
          },
        },
      };
    },
    batchPopUpCallBack(value, data) {
      this.batchPopUpData = undefined;

      if (this.saveDisabled.detail) this.saveDisabled.detail = value;

      if (data) {
        var index = this.productsList.findIndex(
          (x) => x.ItemCode == data.ItemCode && x.LineNo == data.LineNo
        );
        if (index != -1) {
          this.productsList.splice(index, 1, JSON.parse(JSON.stringify(data)));
        }
      }

      var grid =
        this.$refs["roam-despatch-order"].$refs[
          "roamTransactionGrid-" + this.selectedViewValue
        ];

      grid[0].gridRepaint2();

      this.updateTertiaryLabel(
        this.totalScanned + "/" + this.totalStockUMBackorderQty
      );
    },
    async updatePickedQty(index, quantity) {
      let performPick = true;

      if (
        this.productsList[index].StockUMPickedQty + quantity >
        this.productsList[index].StockUMBackorderQty
      ) {
        performPick = false;

        let confirmOverPick = await this.$confirm(
          "You have over picked the order quantity, do you wish to continue?",
          "Over Pick"
        );

        if (confirmOverPick) {
          performPick = true;
        }
      }

      if (performPick) {
        this.productsList[index].StockUMPickedQty = (
          this.productsList[index].StockUMPickedQty + quantity
        ).roundNumber(2);
      }

      this.updateTertiaryLabel(
        this.totalScanned + "/" + this.totalStockUMBackorderQty
      );
      this.saveDisabled.detail = false;
    },
  },
};
</script>

<style lang="scss">
.roam-despatch-radio-list {
  .dx-item.dx-radiobutton {
    margin-bottom: 15px;
  }
}

.roam-despatch-radio-list {
  .dx-item.dx-radiobutton:last-child {
    margin-bottom: 0px;
  }
}

.roam-gc-data-grid .dx-datagrid.dx-gridbase-container {
  .dx-datagrid-headers .dx-header-row td {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .dx-datagrid-rowsview .dx-row.dx-data-row td {
    font-size: 12px;
    // padding-top: 3px !important;
    // padding-bottom: 3px !important;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
